import { User, CreateEditUserPayload } from "./types";
import { rootApi } from "../rootApi";

export const userApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    currentUser: builder.query<User, void>({
      query: () => ({
        url: "user/",
      }),
      providesTags: ["currentUser"],
    }),
    users: builder.query<User[], void>({
      query: () => ({
        url: "users/",
      }),
      providesTags: ["users"],
    }),
    createUser: builder.mutation<User, CreateEditUserPayload>({
      query: (payload) => ({
        url: "users/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["users"],
    }),
    updateUser: builder.mutation<
      User,
      { id: string; payload: CreateEditUserPayload }
    >({
      query: ({ id, payload }) => ({
        url: `users/${id}/`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["users"],
    }),
    deleteUser: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `users/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["users"],
    }),
  }),
});

export const {
  useCurrentUserQuery,
  useUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userApis;
